<div class="row">
  <div *ngIf="!customInvoice.id" class="col-lg-12">
    <div class="pull-left pt-2">{{'doctrine.order.generate_invoice' | translate}} *</div>
    <div class="pull-right">
      <button type="button" class="btn btn-primary" (click)="openGenerateModal()" [disabled]="!isActive || serviceRequest.isArchived">{{'global.generate'|translate}}</button>
    </div>
  </div>
  <div *ngIf="customInvoice.id" class="col-lg-12">
    <p class="pb-2">{{'doctrine.solution.action_invoice.check_file' | translate}}</p>
    <button type="button" class="btn btn-primary btn-file" (click)="openPdfFile()" [disabled]="isPdfDownloading">
      <i class="fa" [ngClass]="isPdfDownloading ? 'fa-spinner fa-spin' : 'fa-file-pdf-o'"></i>
    </button>
  </div>
</div>

<app-generate-invoice
  #generateModal="generateInvoice"
  [customInvoice]="customInvoice?.id ? customInvoice : null"
  [preselectedInvoiceDealer]="dealer"
  [replyItemId]="replyItem?.id"
  (resultInvoice)="updateInvoice($event)"
></app-generate-invoice>
<a #downloadLink href="" download style="display: none"></a>
